document.addEventListener("load", function () {
  // Initialize all sliders found on the page
  setTimeout(() => {
    document.querySelectorAll(".simple-slider").forEach(initializeSlider);
  }, 4000);
});

function initializeSlider(slider) {
  const track = slider.querySelector(".slider-track");
  const slides = slider.querySelectorAll(".slider-slide");
  const prevBtn = slider.querySelector(".slider-prev");
  const nextBtn = slider.querySelector(".slider-next");

  let currentIndex = 0;
  let startX = 0;
  let currentX = 0;
  let isDragging = false;
  let isAnimating = false;
  let dragDistance = 0;
  const MIN_DRAG_DISTANCE = 10; // Minimum distance to consider as drag

  function initSlider() {
    const firstSlideClone = slides[0].cloneNode(true);
    const lastSlideClone = slides[slides.length - 1].cloneNode(true);

    track.appendChild(firstSlideClone);
    track.insertBefore(lastSlideClone, slides[0]);

    track.style.display = "flex";
    track.style.transform = `translateX(-100%)`; // Start at first real slide
    track.style.transition = "transform 0.3s ease-out";

    const allSlides = track.querySelectorAll(".slider-slide");
    allSlides.forEach((slide) => {
      slide.style.userSelect = "none";
      // Force Safari to recalculate width
      slide.style.minWidth = "100%";
      slide.style.flexShrink = "0";
    });
    
    // Force Safari to recalculate layout
    track.offsetHeight;
  }

  function goToSlide(index, instant = false) {
    if (isAnimating) return;

    const totalSlides = slides.length;
    currentIndex = index;

    let targetTranslate = -(currentIndex + 1) * 100;

    if (instant) {
      track.style.transition = "none";
    } else {
      track.style.transition = "transform 0.3s ease-out";
    }

    track.style.transform = `translateX(${targetTranslate}%)`;

    // Handle infinite loop
    if (!instant) {
      isAnimating = true;
      setTimeout(() => {
        isAnimating = false;

        // If we're at the clone slide, jump to the real slide
        if (currentIndex === -1) {
          track.style.transition = "none";
          currentIndex = totalSlides - 1;
          targetTranslate = -(currentIndex + 1) * 100;
          track.style.transform = `translateX(${targetTranslate}%)`;
        } else if (currentIndex === totalSlides) {
          track.style.transition = "none";
          currentIndex = 0;
          targetTranslate = -100;
          track.style.transform = `translateX(${targetTranslate}%)`;
        }

        // Re-enable transitions after the jump
        setTimeout(() => {
          track.style.transition = "transform 0.3s ease-out";
        }, 10);
      }, 300);
    }
  }

  // Event Listeners
  prevBtn.addEventListener("click", (e) => {
    goToSlide(currentIndex - 1);
  });
  nextBtn.addEventListener("click", (e) => {
    goToSlide(currentIndex + 1);
  });

  // Touch/Mouse events
  track.addEventListener("mousedown", (e) => {
    // Ignore if clicked on buttons
    if (e.target.closest(".slider-prev, .slider-next")) return;
    dragStart(e);
  });

  track.addEventListener("touchstart", dragStart);
  window.addEventListener("mousemove", drag);
  window.addEventListener("touchmove", drag);
  window.addEventListener("mouseup", dragEnd);
  window.addEventListener("touchend", dragEnd);
  window.addEventListener("mouseleave", dragEnd);

  function dragStart(e) {
    if (isAnimating) return;
    startX = e.type === "mousedown" ? e.clientX : e.touches[0].clientX;
    currentX = startX;
    isDragging = true;
    dragDistance = 0;
    track.style.transition = "none";
  }

  function drag(e) {
    if (!isDragging) return;

    e.preventDefault(); // Prevent scrolling while dragging
    currentX = e.type === "mousemove" ? e.clientX : e.touches[0].clientX;
    const diff = currentX - startX;
    dragDistance = Math.abs(diff);

    if (dragDistance > MIN_DRAG_DISTANCE) {
      const slideWidth = slider.offsetWidth;
      const dragRatio = (diff / slideWidth) * 100;
      const targetTranslate = -((currentIndex + 1) * 100) + dragRatio;
      track.style.transform = `translateX(${targetTranslate}%)`;
    }
  }

  function dragEnd(e) {
    if (!isDragging) return;
    
    isDragging = false;
    track.style.transition = "transform 0.3s ease-out";

    if (dragDistance > MIN_DRAG_DISTANCE) {
      const diff = currentX - startX;
      const slideWidth = slider.offsetWidth;
      const moveRatio = Math.abs(diff / slideWidth);

      if (moveRatio > 0.1) {
        if (diff > 0) {
          goToSlide(currentIndex - 1);
        } else {
          goToSlide(currentIndex + 1);
        }
      } else {
        goToSlide(currentIndex);
      }

      // Prevent click events right after drag
      const preventClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        track.removeEventListener("click", preventClick, true);
      };
      track.addEventListener("click", preventClick, true);
      setTimeout(() => {
        track.removeEventListener("click", preventClick, true);
      }, 300);
    } else {
      // If dragDistance is small, treat as a click and do nothing
      goToSlide(currentIndex);
    }
  }

  initSlider();
  goToSlide(0, true);
}
